import React from "react";
import ICompositeFieldData from "../../../../../../model/interface/dataStorage/field/composite/ICompositeFieldData";
import IField, {IFieldOptions} from "../../../../../../model/interface/dataStorage/IField";
import Map from "../../../../../shared/map/Map";
import {Tag} from "antd";
import card from "../../card/Card";


interface IProps {
    options: IFieldOptions,
    value: ICompositeFieldData,
    field?: IField
}

interface IState {
}

class CompositeFieldCoordinates extends React.Component<IProps, IState> {

    constructor(props: Readonly<IProps> | IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {options, value} = this.props

        return (
            <div>
                {(options.presenter === 'coordinates' || (options.presenter === undefined)) && value?.[this.LATITUDE] && value?.[this.LONGITUDE] && (
                    <Tag color={'success'}>{value?.[this.LATITUDE]}, {value?.[this.LONGITUDE]}</Tag>
                )}
                {(options.presenter === 'map-coordinates') && (
                    <div>
                        {(value?.[this.LATITUDE] && value?.[this.LONGITUDE]) && (
                            <Tag color={'success'}>{value?.[this.LATITUDE]}, {value?.[this.LONGITUDE]}</Tag>
                        )}
                        {options.card_view && (
                            <Map points={value?.[this.LATITUDE] && value?.[this.LONGITUDE]? [{lat: value?.[this.LATITUDE], long: value?.[this.LONGITUDE]}] : []} width={options.presenterWidth}
                                 height={options.presenterHeight}/>
                        )}
                    </div>

                )}
                {(options.presenter === 'map') && (
                    <Map points={value?.[this.LATITUDE] && value?.[this.LONGITUDE]? [{lat: value?.[this.LATITUDE], long: value?.[this.LONGITUDE]}] : []} width={options.presenterWidth}
                         height={options.presenterHeight}/>
                )}
            </div>
        )
    }

    getFieldName = (property: string) => {
        const {field} = this.props
        return field ? field.name + '_' + property : ''
    }

    LONGITUDE = this.getFieldName('longitude')
    LATITUDE = this.getFieldName('latitude')
}

export default CompositeFieldCoordinates
